// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"93d855b9","213":"7e289faf","281":"a526f2d2","390":"a920b26f","533":"9bc5d65f","626":"3aa35bf4","713":"6286e536","869":"d5323eff","936":"d8b02d85","953":"ca31abc2"}[chunkId] + ".chunk.js";
};